import PropTypes from 'prop-types';
// @mui
import { useDispatch, useSelector } from 'react-redux';
import { LoadingButton } from '@mui/lab';
import { Dialog, DialogTitle, DialogActions, Button } from '@mui/material';
import { declineHandover } from '../store/handoverActions';

Decline.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  handoverId: PropTypes.string,
};

export default function Decline({ open, handleClose, handoverId }) {
  const dispatch = useDispatch();

  const { isLoading } = useSelector((state) => state.disposalReducer);

  const handleApproveMaintenance = async () => {
    dispatch(declineHandover(handoverId));
    handleClose();
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{'You are about to decline handover request.'}</DialogTitle>
      <DialogActions>
        <Button size="small" variant="contained" color="error" onClick={handleClose}>
          Cancel
        </Button>
        <LoadingButton
          type="submit"
          size="small"
          variant="contained"
          loading={isLoading}
          onClick={handleApproveMaintenance}
        >
          Proceed
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
